import TruckingViewSection from './TruckingViewSection';

export default TruckingViewSection;
